import { useTranslation } from 'react-i18next';
import { Icon } from './primitives';

export default function SheetCloseButton({
  onClick,
  testId,
  className = '',
  iconName = 'clear',
  ariaLabel,
}) {
  const { t } = useTranslation();

  return (
    <button
      type="button"
      onClick={onClick}
      aria-label={ariaLabel || t('common.close')}
      className={[
        'absolute right-6 top-[21px] flex h-9 w-9 items-center justify-center',
        'rounded-full bg-white/[0.08] text-text-primary',
        'focus:outline-none focus-visible:ring-checkbox focus-visible:ring-base-white',
        className,
      ].join(' ')}
      data-testid={testId}
    >
      <Icon name={iconName} size={20} />
    </button>
  );
}
